import * as React from 'react';
import { CardSummary } from '../../../types/card';
import Diners from './images/dinners-club.png';
import JCB from './images/jcb.png';
import Visa from './images/visa.png';
import AmericanExpress from './images/american-express.png';
import MasterCard from './images/mastercard.png';
import { Button } from '../../../../commonv2/components/Button';
import './cardSummaryView.module.scss';

type BrandProps = {
  brand: string;
  className?: string;
  styleName?: string;
};

export const BrandIcon = ({ brand, className }: BrandProps) => {
  if (brand.toLowerCase() == 'visa') {
    return <img className={className} src={Visa} />;
  }
  if (brand.toLowerCase().startsWith('american')) {
    return <img className={className} src={AmericanExpress} />;
  }
  if (brand.toLowerCase().startsWith('diners')) {
    return <img className={className} src={Diners} />;
  }
  if (brand.toLowerCase().startsWith('jcb')) {
    return <img className={className} src={JCB} />;
  }
  if (brand.toLowerCase().startsWith('master')) {
    return <img className={className} src={MasterCard} />;
  }
  return <span>{brand}</span>;
};

type SummaryProps = {
  card: CardSummary;
};

export const CardInfo = ({ card }: SummaryProps) => {
  return (
    <div styleName="first-group">
      <div styleName="label">クレジットカード</div>
      <div styleName="card-info">
        <div styleName="brand-icon">
          <BrandIcon brand={card.brand} />
        </div>
        <div styleName="last4">{card.last4}</div>
        <div styleName="exp">
          {card.exp_month}/{String(card.exp_year).substr(String(card.exp_year).length - 2)}
        </div>
      </div>
    </div>
  );
};

type Props = {
  card: CardSummary;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onModificationRequested: () => any;
};

export const CardSummaryView = ({ card, onModificationRequested }: Props) => {
  return (
    <div styleName="card-summary">
      <CardInfo card={card} />
      <div styleName="button-wrapper">
        <Button type="secondary" layout="inline" onClick={onModificationRequested}>
          変更する
        </Button>
      </div>
    </div>
  );
};
